'use client'
import Link from "next/link"
import {
    ArrowUpRight
} from "lucide-react"

import { Button } from "@/components/ui/button"
import {
    Card,
    CardContent,
    CardDescription,
    CardHeader,
    CardTitle,
} from "@/components/ui/card"

export default function TransactionHeader(user: any) {

    return (
        <CardHeader className="flex flex-row items-center">
            <div className="grid gap-2">
                <CardTitle>Transactions</CardTitle>
                <CardDescription>
                    Recent transactions from your store.
                </CardDescription>
            </div>
            <Button size="sm" className="ml-auto gap-1" onClick={() => {
                console.log('View All', user.transaction.amount)
            }}>
                View All
                <ArrowUpRight className="h-4 w-4" />

            </Button>
        </CardHeader>
    )
}
